import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ReactNode } from "react";

interface Tab {
  value: string;
  label: string;
  content: ReactNode;
}

interface SettingsTabsProps {
  defaultValue?: string;
  value?: string;
  tabs: Tab[];
  onValueChange?: (value: string) => void;
}

export function SettingsTabs({ defaultValue, value, tabs, onValueChange }: SettingsTabsProps) {
  return (
    <div className="p-4">
      <Tabs 
        value={value}
        defaultValue={defaultValue || tabs[0]?.value} 
        onValueChange={onValueChange}
        className="w-full"
      >
        <TabsList>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value} data-testid={`settings-tab-${tab.value}`}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value} className="mt-4">
            {tab.content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
